import {
  Component,
  HostListener,
  Inject,
  inject,
  Injectable,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatToolbarModule } from "@angular/material/toolbar";
import { AppLayoutComponent, DataService } from "fg-library";
import { FgSchemaImportBuilderComponent } from "./fg-schema-import-dialog-box/fg-schema-import-dialog-box.component";
import { MatRippleModule } from "@angular/material/core";
import {
  extractLinks,
  extractModelFields,
  fetchAllLinkModelMetaData,
  generateListColumns,
  getAllLinkModels,
  getFieldsByGroup,
  getModelMetaData,
  groupModelFieldsByFieldGroup,
} from "./utils/dataUtils";
import { JsonPipe } from "@angular/common";

import { listViewDefaulttemplate } from "./utils/listPage/listviewtemplate";
import { createBaseFormTemplate } from "./utils/listPage/baseFormTemplate";
import { lisComponentTemplate } from "./utils/listPage/listBaseTemplate";
import {
  CreateCalendatViewPage,
  CreateListPage,
  CreateListPageTemplate,
  TimelineViewPage,
} from "./utils/listPage/ListPageGenertor";
import {
  generateFormFieldComponents,
  getCreateForm,
  getPreviewForm,
  getViewForm,
} from "./utils/createPage/cratePageGeneror";
import { NgForm } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { getRecordDetail } from "./utils/common/apiService";
import { MatDrawer } from "@angular/material/sidenav";
import {
  bentoVariations,
  layoutVariationMap,
} from "./utils/common/layyoutVariationMap";
import { v4 as uuidv4 } from "uuid";
import { getPageTemplate } from "./utils/createPage/fullFormSchema";
import { generateApplicableViews } from "./utils/listPage/viewFinder";
import {
  ChartDefinition,
  getChartVariants,
} from "./utils/dashboard/chartVariations";
import { ChartVariantDialogComponent } from "./chart-variant-dialog.component";
import { LayoutService } from "../../shared/components/main-nav/layoutservice";
import {
  generateChart,
  generateDynamicChart,
} from "./utils/dashboard/chartComponentGenerator";
import {
  getDashboardBentoForm,
  getDashboardForm,
} from "./utils/dashboard/dashboardGenertor";
import { wrapComponentsForBento } from "./utils/createPage/dashboardLayout";
import { callVariant } from "./utils/dashboard/transactionViewGenerator";
import { getFilterForm } from "./utils/common/filterGenerator";

@Component({
    selector: "fg-dynamic-page-builder",
    styleUrls: ["./fg-dynamic-page-builder.component.scss"],
    templateUrl: "./fg-dynamic-page-builder.component.html",
    standalone: false
})
@Injectable({
  providedIn: "root",
})
export class FgDynamicPageBuilder {
  allModels: any = [];
  readonly dialog = inject(MatDialog);
  localConfig: any = {};
  formFields: any;
  listFields: any;
  listVariation: any;
  dashboardPage: any;
  private layoutService: LayoutService;
  layoutVariations = [
    { label: "Simple", value: "simple", layout: "AUTO", pagelayout: "" },
    {
      label: "Card Simple",
      value: "card-simple",
      layout: "AUTO",
      pagelayout: "",
    },
    { label: "Tabs", value: "tabs", layout: "AUTO", pagelayout: "" },
    { label: "Stepper", value: "stepper", layout: "AUTO", pagelayout: "" },
  ];
  designerReady: boolean = false;
  showDesigner: boolean = false;
  constructor(
    private dataService: DataService,
    private snackBar: MatSnackBar
  ) {}
  ngOnInit(): void {
    this.localConfig.modelsAvailable = false;
    this.fetchAllModels();
    this.layoutService.setChartType("BAR");
  }

  fetchAllModels() {
    var filterData = {
      filter: { fetchFromCache: false },
      select:
        "[ activeCode,categoryCode,code,description,id,lastUpdatedBy,lastUpdatedOn,name,parentTypeCode,statusCode, tags]",
      sort: '["lastUpdatedOn","DESC"]',
    };

    this.dataService
      .getCustomServiceData("fgEntityType", filterData)
      .subscribe((response) => {
     //   //console.log(response);
        this.allModels = response;
        this.localConfig.modelsAvailable = true;
      });
  }
  async onModelClick(identifierKey: string, modelName: string): Promise<void> {
    this.listVariation = undefined;
    this.localConfig.pageInfo = undefined;
    this.localConfig.listPageInfo = undefined;
    this.localConfig.mode = "LIST";
    this.localConfig.modelName = modelName;
    this.localConfig.pageSchema = undefined;

    const parsedKey = identifierKey;

    // Await the primary model metadata
    const result = await getModelMetaData(this.dataService, parsedKey);
    this.localConfig.currentModel = result;
    this.listVariation = generateApplicableViews(
      this.localConfig.currentModel.properties
    );
    ////console.log(this.listVariation);
    // Extract fields and links
    const fieldGroups = getFieldsByGroup(this.localConfig.currentModel);
    this.localConfig.currentlinks = extractLinks(this.localConfig.currentModel);

    // Await all link model metadata before proceeding
    const linkModelMap = await getAllLinkModels(
      this.dataService,
      this.localConfig.currentlinks
    );
    this.localConfig.currentLinkModel = linkModelMap;

    // Proceed with remaining assignments
    this.localConfig.currentListFields = fieldGroups.listFields;
    this.localConfig.currentFormFields = fieldGroups.formFields;
    this.localConfig.currentTypeCode = result.type.typeCode;
    this.localConfig.currentSubTypeCode = result.type.subTypeCode;
    //console.log(this.localConfig.currentListFields);
    //console.log(this.localConfig.currentModel);

    this.localConfig.searchableFields =
      this.localConfig.currentModel.properties.filter(
        (field) => field["isSearchable"] === true
      );
    //console.log(this.localConfig.searchableFields);

    this.localConfig.pageSchema = CreateListPage(
      this.localConfig.currentListFields,
      this.localConfig.currentTypeCode,
      this.localConfig.currentSubTypeCode,
      this.localConfig.searchableFields,
      this.localConfig.currentModel.type.name,
      this.localConfig.currentModel.type.enableWorkflow
    );

    const fullListForm = this.generateFullForm(this.localConfig.pageSchema);

    //console.log("fullForm :", fullListForm);
    this.localConfig.listPageInfo = fullListForm;

    this.localConfig.currentFieldComponents = {
      EDIT: generateFormFieldComponents(
        this.localConfig.currentFormFields,
        "EDIT",
        "RENDER",
        this.localConfig.currentLinkModel
      ),
      VIEW: generateFormFieldComponents(
        this.localConfig.currentFormFields,
        "VIEW",
        "RENDER",
        this.localConfig.currentLinkModel
      ),
    };

    //console.log("------- Local Config -------------");
    //console.log(this.localConfig);
  }

  //   export async function getModelMetaData(
  //   dataService: DataService,
  //   code: any
  // ): Promise<any> {

  searchText: string = "";

  filteredModels(): any[] {
    const search = this.searchText.toLowerCase();
    return this.allModels.filter(
      (model) =>
        model.name?.toLowerCase().includes(search) ||
        model.categoryCode?.toLowerCase().includes(search) ||
        model.code?.toLowerCase().includes(search) ||
        model.identifierKey?.toLowerCase().includes(search)
    );
  }

  onAddClick(): void {
    //this.localConfig.pageSchema = undefined;
    this.localConfig.mode = "EDIT";
    this.localConfig.formData = {
      SUB_TYPE_CODE: this.localConfig.currentSubTypeCode,
      TYPE_CODE: this.localConfig.currentTypeCode,
      STAGE_CODE: "INITIATION",
    };

    //this.prepareAllVariationLayouts();
    setTimeout(() => {
      const selectedVariation = layoutVariationMap.simple;
      // this.localConfig.createPageSchema = this.getForm(selectedVariation);
      this.localConfig.pageInfo = this.generateFullForm(
        this.getForm(selectedVariation)
      );
      this.designerReady = false;
    }, 0);

    setTimeout(() => {
      this.prepareAllVariationLayouts();
    }, 0);
    //console.log("Add button clicked!");
    setTimeout(() => {
      this.prepareAllVariationLayouts();
    }, 0);

    // Your actual logic here
  }
  @HostListener("window:DynamicEditEvent", ["$event"])
  dynamicEdit(event: any) {
    this.localConfig.pageInfo = undefined;
    //console.log(" event Emotted on edit ..... ", event.detail.data.ID);
    this.localConfig.mode = "EDIT";
    this.localConfig.recordObject = event.detail.data;
    this.localConfig.pageInfo = this.generateFullForm(
      this.getForm(layoutVariationMap.simple)
    );
    // getRecordDetail(
    //   this.dataService,
    //   this.localConfig,
    //   event.detail.data.REFERENCE_ID
    // ).then((result) => {
    //   this.localConfig.formData = result[0];

    //     this.localConfig.pageInfo = this.generateFullForm(
    //     this.getForm(layoutVariationMap.simple)
    //   );

    // });
    setTimeout(() => {
      this.prepareAllVariationLayouts();
    }, 0);
  }
  @HostListener("window:DynamicViewEvent", ["$event"])
  dynamicView(event: any) {
    this.localConfig.mode = "VIEW";
    //console.log(" event Emotted on edit ..... ", event.detail.data.ID);
    this.localConfig.recordObject = event.detail.data;
    this.localConfig.pageInfo = this.generateFullForm(
      this.getForm(layoutVariationMap.simple)
    );
    // getRecordDetail(
    //   this.dataService,
    //   this.localConfig,
    //   event.detail.data.REFERENCE_ID
    // ).then((result) => {
    //   this.localConfig.formData = result[0];

    //   this.localConfig.createPageSchema = this.getForm(
    //     layoutVariationMap.simple
    //   );
    // });
    setTimeout(() => {
      this.prepareAllVariationLayouts();
    }, 0);
  }

  getForm(layoutConfig: any): any {
    const pagetitle = this.localConfig.pagetitle
      ? this.localConfig.pagetitle
      : this.localConfig.modelName;

    const modelForm = this.localConfig.currentLinkModel;

    let currentForm = getCreateForm(
      this.localConfig.currentFieldComponents[this.localConfig.mode],
      false,
      layoutConfig,
      pagetitle,
      this.localConfig.currentLinkModel,
      {}
    );

    const linkModelMap = this.localConfig.currentLinkModel;
    this.localConfig.currentLinkFieldComponents = {};
    let modalList = {
      type: "fgcontainer",
      uuid: crypto.randomUUID(),
      children: [],
    };
    for (const linkKey in linkModelMap) {
      if (linkModelMap.hasOwnProperty(linkKey)) {
        const model = linkModelMap[linkKey];
        const formFields = model; // fallback if formFields are nested
        //console.log(this.localConfig.currentLinkFieldComponents);
        this.localConfig.currentLinkFieldComponents[linkKey] =
          generateFormFieldComponents(
            formFields,
            "EDIT",
            "RENDER",
            this.localConfig.currentLinkModel
          );
        const modalProp = { modalId: linkKey };

        const linkForm = getCreateForm(
          this.localConfig.currentLinkFieldComponents[linkKey],
          true,
          layoutConfig,
          pagetitle,
          this.localConfig.currentLinkModel,
          modalProp
        );
        modalList.children.push(linkForm);
      }
      //console.log(this.localConfig.currentLinkFieldComponents);
    }
    currentForm.push(modalList);

    //console.log(currentForm);

    return currentForm;
  }

  generateFullForm(formList: any): any {
    const pageInfo = getPageTemplate(
      this.localConfig.currentTypeCode,
      this.localConfig.currentSubTypeCode,
      formList
    );

    //console.log(this.localConfig.pageInfo);

    return pageInfo;
  }

  onListlick(): void {
    this.localConfig.mode = "LIST";

    //console.log("Add button clicked!");
    // Your actual logic here
  }

  submitForm(form: NgForm) {
    if (form.valid) {
      this.saveForm(form);
    } else {
      this.snackBar.open(
        "Please fix validation errors before submitting.",
        "Close",
        {
          duration: 3000, // milliseconds
          verticalPosition: "top", // or 'bottom'
          panelClass: ["snack-bar-error"], // optional custom styling
        }
      );
    }
  }
  saveForm(form: NgForm) {
    let queryRequest: any = {};
    queryRequest.typeCode = this.localConfig.currentTypeCode;
    queryRequest.subTypeCode = this.localConfig.currentSubTypeCode;
    queryRequest.action = "Submit";
    queryRequest.actionCode = "Submit";
    queryRequest.entityData = this.localConfig.formData;
    this.dataService.saveMutationService(queryRequest).subscribe(
      async (response) => {
        if (
          response.status == "ERROR" ||
          (response.validationError && response.validationError.length > 0)
        ) {
          // result.errorMessage = response.message ? response.message : 'Invalid OTP';
        } else {
        }
      },
      (error: any) => {
        //console.log("Service error");
      }
    );

    this.localConfig.mode = "LIST";
  }

  // onVariationSelect(variation: "simple" | "card-simple" | "tabs" | "stepper") {
  //   const currentMode = this.localConfig.mode;
  //   this.localConfig.createPageSchema = undefined;
  //   this.localConfig.mode = "LOADING";

  //   setTimeout(() => {
  //     this.localConfig.viewVariation = variation;
  //     this.localConfig.createPageSchema = this.getForm("simple"); // wraps with new variation
  //     this.localConfig.mode = currentMode;
  //   }, 100);
  // }
  setLayoutByVariation(variationValue: string) {
    const variation = this.layoutVariations.find(
      (v) => v.value === variationValue
    );
    if (!variation) return;

    const currentMode = this.localConfig.mode;
    this.localConfig.createPageSchema = undefined;
    this.localConfig.mode = "LOADING";

    setTimeout(() => {
      // Call your existing getForm method
      this.localConfig.pageInfo = this.generateFullForm(
        this.getForm(variation.layout)
      );
      this.localConfig.viewVariation = variation.value;
      this.localConfig.mode = currentMode;
    }, 0);
  }

  variationLayouts: any;

  async prepareAllVariationLayouts() {
    this.designerReady = false;
    const layoutEntries = await Promise.all(
      Object.entries(layoutVariationMap).map(async ([key, config]) => {
        const variation = { ...config, value: key };
        variation.pagelayout = await this.getLayout(key);
        return variation;
      })
    );

    this.variationLayouts = layoutEntries;
    //console.log("Prepared Layouts:", this.variationLayouts);
    this.designerReady = true;
  }

  //   export function getCreateForm(
  //   formFields: any,
  //   viewVariationKey: any,
  //   title: any,
  //   mode:any
  // ): any {
  getLayout(layoutConfig: any): any {
    return getPreviewForm(
      this.localConfig.currentFormFields,
      layoutConfig,
      this.localConfig.pagetitle,
      this.localConfig.mode,
      this.localConfig.currentLinkModel
    );
  }

  selectedVariation: any = null;

  openVariationPreview(variation: any, drawer: MatDrawer) {
    this.selectedVariation = variation;
    drawer.open();
  }
  switchView(selectedVariation: any) {
    const currentMode = this.localConfig.mode;
    this.localConfig.pageInfo = undefined;
    //this.localConfig.mode = 'LOADING';
    // selectedVariation.pagelayout = [];
    this.designerReady = false;
    setTimeout(() => {
      this.localConfig.pageInfo = this.generateFullForm(
        this.getForm(selectedVariation)
      );
      this.localConfig.mode = currentMode;
      this.designerReady = true;
    }, 100);
  }

  switchListView(variation) {
    this.localConfig.listPageInfo = undefined;
this.localConfig.pageSchema = undefined;
    if (variation.viewVariation == "AllView") {
      const baseListing = CreateListPage(
        this.localConfig.currentListFields,
        this.localConfig.currentTypeCode,
        this.localConfig.currentSubTypeCode,
        this.localConfig.searchableFields,
        this.localConfig.currentModel.type.name,
        this.localConfig.currentModel.type.enableWorkflow,
        undefined,
        true
      );
      this.listVariation.forEach((variation) => {
        if(variation == 'Tabular') variation = undefined; // for default tabular
        const thisPage = CreateListPage(
          this.localConfig.currentListFields,
          this.localConfig.currentTypeCode,
          this.localConfig.currentSubTypeCode,
          this.localConfig.searchableFields,
          this.localConfig.currentModel.type.name,
          this.localConfig.currentModel.type.enableWorkflow,
          variation,
          true
        );

        if (thisPage && thisPage.defaultWidget) {
          const widgetExists = baseListing.widgets.some(
            (w) => w.codeValue === thisPage.defaultWidget
          );

          if (!widgetExists) {
            // Assign corresponding view only if not already assigned
            switch (thisPage.defaultWidget) {
              case "List":
                if (!baseListing.listView && thisPage.listVariation) {
                  baseListing.listView = thisPage.listVariation;
                }
                break;
              case "card":
                if (!baseListing.cardView && thisPage.listVariation) {
                  baseListing.cardView = thisPage.listVariation;
                }
                break;
              case "Calendar":
                if (!baseListing.calendarView && thisPage.calendarView) {
                  baseListing.calendarView = thisPage.calendarView;
                }
                break;
              case "Timeline":
                if (!baseListing.timelineView && thisPage.timelineView) {
                  baseListing.timelineView = thisPage.timelineView;
                }
                break;
              case "Kanban":
                if (!baseListing.kanbanView && thisPage.kanbanView) {
                  baseListing.kanbanView = thisPage.kanbanView;
                }
                break;
            }

            // Push only if codeValue is not already in widgets
            baseListing.widgets.push({
              codeValue: thisPage.defaultWidget,
              name: thisPage.defaultWidget,
              selected: true,
            });
          }
        }
      });

      setTimeout(() => {
         const listPage = CreateListPageTemplate(
              baseListing,
              this.localConfig.selec,
              this.localConfig.currentSubTypeCode,
              this.localConfig.searchableFields,
              this.localConfig.currentModel.type.name,
              this.localConfig.currentModel.type.enableWorkflow,
            );
        this.localConfig.pageSchema = listPage;
        const fullListForm = this.generateFullForm(this.localConfig.pageSchema);
        this.localConfig.listPageInfo = fullListForm;
      }, 100);
    } else {

          this.localConfig.listPageInfo = undefined;
      this.localConfig.pageSchema = undefined;
      setTimeout(() => {
        this.localConfig.pageSchema = CreateListPage(
          this.localConfig.currentListFields,
          this.localConfig.currentTypeCode,
          this.localConfig.currentSubTypeCode,
          this.localConfig.searchableFields,
          this.localConfig.currentModel.type.name,
          this.localConfig.currentModel.type.enableWorkflow,
          variation
        );
        const fullListForm = this.generateFullForm(this.localConfig.pageSchema);
        this.localConfig.listPageInfo = fullListForm;
      }, 100);
    }
  }
  variants: ChartDefinition[] = [];

  openChartVariantDialog_old() {
    const rawFields = this.localConfig.currentModel.properties || []; // adjust according to your model
    const modelName = this.localConfig.currentModel.type.subTypeCode;

    this.dialog.open(ChartVariantDialogComponent, {
      width: "90vw",
      maxHeight: "90vh",
      height: "90vh",
      data: {
        variants: getChartVariants(rawFields, modelName),
        model: modelName,
      },
      autoFocus: false,
    });
  }

  openChartVariantDialog(): void {
    this.localConfig.dashboardPage = undefined;
    const rawFields = this.localConfig.currentModel.properties || []; // adjust according to your model
    const modelName = this.localConfig.currentModel.type.subTypeCode;
    const dialogRef = this.dialog.open(ChartVariantDialogComponent, {
      width: "80%",
      height: "90%",
      disableClose: false,
      data: {
        variants: getChartVariants(rawFields, modelName),
        model: modelName,
      },
    });

    dialogRef.afterClosed().subscribe((selectedVariants) => {
      if (selectedVariants) {
        this.handleSelectedVariants(selectedVariants); // call your handler
      }
    });
  }

  handleSelectedVariants(variants: any[]): void {
    this.localConfig.mode = "DASHBOARD";
    let components: any[] = []; // Define this at the class level
    //console.log("Received variants in builder:", variants);

    components = []; // reset if needed

    for (const variant of variants) {
      variants.forEach((variant) => {
        if (!variant.component && variant.chartType == "Timeline") {
          //console.log(" List Page ... ");
          variant.component = this.getTransactionComponent(variant);
        } else if (!variant.component) {
          variant.component = generateChart(
            variant,
            this.localConfig.currentModel.type.subTypeCode,
             this.localConfig.searchableFields
          );
        }
      });

      if (variant.component) {
        variant.component.isOptionChart = variant.selectedVariation;
        variant.component.chartSubtype = variant.selectedVariation;
        variant.component.isFitContainerEnabled = true;
        components.push(variant.component);
      }
    }
    let dashboardForm = getDashboardForm(
      components,
      layoutVariationMap["dashboard-3col"],
      this.localConfig.currentModel.type.name + " Dashboard"
    );
    let filterForm = getFilterForm(this.localConfig.searchableFields);
      dashboardForm?.push(filterForm);
    //dashboard-3col
    setTimeout(() => {
      const fullForm = this.generateFullForm(dashboardForm);
      //console.log("Prepared Form:", fullForm);
      this.localConfig.dashboardPage = fullForm;
    }, 0);
  }

  getTransactionComponent(variant: any): any {
    const calvariation = callVariant(variant.dateField[0]);
    let listTemplte: any = {};
    if (variant.selectedVariation == "Calendar") {
      listTemplte = CreateCalendatViewPage(
        this.localConfig.currentListFields,
        variant.dateField[0].name,
        []
      );

      listTemplte.defaultWidget = "Calendar";
      listTemplte.calendarView.showFullCalender = false;
    } else {
      listTemplte = TimelineViewPage(
        this.localConfig.currentListFields,
        variant.dateField[0].name
      );

      listTemplte.defaultWidget = "Timeline";
    }

    const calList = lisComponentTemplate;

    calList.subTypeCode = this.localConfig.currentModel.type.subTypeCode;
    calList.typeCode = this.localConfig.currentModel.type.typeCode;
    calList.template = JSON.stringify(listTemplte);
    calList.name = variant.dateField[0].displayName;
    const listComponent = {
      type: "fgListPage",
      subtype: "list",
      cat: "fgListPage",
      icon: "  fa fa-list",
      name: "List Page",
      options: {},
      condition: {},
      isCoreConfig: true,
      category: "INPUT",
      uuid: "634c9caa-d1c9-4e1e-9ea7-00297bfce1fe",
      option: {},
      styles: {},
      showEmptyState: true,
      listSchema: JSON.stringify(calList),
    };
    return listComponent;
  }
  generteBentoBoard(type:string, columns:any) {
    this.localConfig.mode = "DASHBOARD";
    this.localConfig.dashboardPage = undefined;
    let components = []; // reset if needed
    const rawFields = this.localConfig.currentModel.properties || []; // adjust according to your model
    const modelName = this.localConfig.currentModel.type.subTypeCode;
    const variants = getChartVariants(rawFields, modelName);
    //console.log(variants);

    for (const variant of variants) {
      variants.forEach((variant) => {
        if (!variant.component && variant.chartType == "Timeline") {
          //console.log(" List Page ... ");
          variant.component = this.getTransactionComponent(variant);
        } else if (!variant.component) {
          variant.component = generateDynamicChart(
            variant,
            this.localConfig.currentModel.type.subTypeCode,
            this.localConfig.searchableFields
          );
        }
      });

      if (variant.component) {
        variant.component.isOptionChart = variant.selectedVariation;
        variant.component.chartSubtype = variant.selectedVariation;
        variant.component.isFitContainerEnabled = true;
        components.push(variant.component);
      }
    }
    //console.log(components);

    setTimeout(() => {
      const variationConfig = bentoVariations["bento-3col"];
      const wrapped = getDashboardBentoForm(
        components,
        variationConfig,
       this.localConfig.currentModel.type.name + " Dashboard",
        type,
       columns
      );

      let filterForm = getFilterForm(this.localConfig.searchableFields);
      wrapped?.push(filterForm);
      const fullForm = this.generateFullForm(wrapped);

      // get Filter form


      //console.log("Prepared Form:", fullForm);
      this.localConfig.dashboardPage = fullForm;
    }, 0);
  }
  selectedListVariation: any = null;

selectVariation(variation: any) {
  this.selectedListVariation = this.selectedListVariation === variation ? null : variation;
  this.switchListView(variation);
}


dashboardVariants = [
{ label: '3-9', icon: 'view_column', type: 'PRESET', columns: [3, 9] },
  { label: '4-8', icon: 'view_column', type: 'PRESET', columns: [4, 8] },
  { label: '5-7', icon: 'view_column', type: 'PRESET', columns: [5, 7] },
  { label: '6-6', icon: 'view_column', type: 'PRESET', columns: [6, 6] },
  { label: '7-5', icon: 'view_column', type: 'PRESET', columns: [7, 5] },
  { label: '8-4', icon: 'view_column', type: 'PRESET', columns: [8, 4] },
  { label: '9-3', icon: 'view_column', type: 'PRESET', columns: [9, 3] },

  // 3-column presets
  { label: '3-3-6', icon: 'view_column', type: 'PRESET', columns: [3, 3, 6] },
  { label: '3-4-5', icon: 'view_column', type: 'PRESET', columns: [3, 4, 5] },
  { label: '3-5-4', icon: 'view_column', type: 'PRESET', columns: [3, 5, 4] },
  { label: '3-6-3', icon: 'view_column', type: 'PRESET', columns: [3, 6, 3] },
  { label: '4-3-5', icon: 'view_column', type: 'PRESET', columns: [4, 3, 5] },
  { label: '4-4-4', icon: 'view_column', type: 'PRESET', columns: [4, 4, 4] },
  { label: '4-5-3', icon: 'view_column', type: 'PRESET', columns: [4, 5, 3] },
  { label: '5-3-4', icon: 'view_column', type: 'PRESET', columns: [5, 3, 4] },
  { label: '5-4-3', icon: 'view_column', type: 'PRESET', columns: [5, 4, 3] },
  { label: '6-3-3', icon: 'view_column', type: 'PRESET', columns: [6, 3, 3] }

];

//{ label: 'Random Bento', icon: 'leaderboard' , type:'RANDOM-BENTO'}, include later there are some issues now.

randomVariants = [
  { label: 'Unique Rows', icon: 'assessment', type:'ROW-UNIQUE'},];
twoColumnVariants = this.dashboardVariants.filter(d => d.columns.length === 2);
threeColumnVariants = this.dashboardVariants.filter(d => d.columns.length === 3);
selectDashboard(variant: any) {
  //console.log('Switching to:', variant.label);
  // logic to switch dashboard
}
changeLanguage(lang:String){
  console.log(' do nothing');
}

}
